export const partnerIconMixin = {
    methods: {
        getIcons(partner, iconType) {
            const iconsStr = partner?.icons?.[iconType];
            if (!iconsStr || typeof iconsStr !== 'string') {
                return [];
            }
            return iconsStr.split('*').filter((icon) => !!icon);
        },
        getIconUrl(icon, width, height) {
            return `${icon}?d=${width}x${height}`;
        },
    },
};
